import { PostType } from 'src/hook/usePosts';

export enum MediaDisplayFormat {
  MiniSquare = 'mini-square',
  Square = 'square'
}

export type PostMediaPreviewProps = {
  id: number;
  mediaType: PostType;
  displayFormat?: MediaDisplayFormat;
  className?: string;
};

export type Dimensions = {
  [key in MediaDisplayFormat]: {
    width: number;
    height: number;
  };
};
